import React from 'react';
import classNames from 'classnames';

import SmsSubscriptionForm from './SmsSubscriptionForm';
import PropTypes from 'prop-types';

export default class SmsSubscriptionTrigger extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.onLoad(this.props.phone);
  }

  render() {
    const {
      hideSmsSubscriptionForm,
      isSubmitting,
      phone,
      onSubmit,
      statusMessage,
      statusMessageError,
    } = this.props;
    const initialValues = {
      phone,
    };

    return (
      <div className="Message">
        <div
          className={
            statusMessage
              ? 'text SmsSubscriptionTrigger__status-message'
              : statusMessageError
                ? 'text red SmsSubscriptionTrigger__status-message'
                : 'hide'
          }
        >
          {statusMessage || statusMessageError}
        </div>
        <div className={hideSmsSubscriptionForm ? 'hide' : ''}>
          <div className="h5 navy SmsSubscriptionTrigger__title">
            Get First Access To JUUL Offers
          </div>
          <div className="Message__body SmsSubscriptionTrigger__description">
            Sign up for SMS alerts to get exclusive offers and news. Carrier
            message and data rates may apply.
          </div>
          <SmsSubscriptionForm
            isSubmitting={isSubmitting}
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/sms_subscriptions/components/SmsSubscriptionTrigger.js